module.exports = __webpack_public_path__ + "img/android.e78ab098.svg";